import React from 'react';
import {useSelector} from "react-redux";
import ContentViewComponent from "../../../Component/ContentViewComponent";
import TableComponent from "../../../Component/TableComponent";
import ApiHandler from "../../../Handler/ApiHandler";
import {getRoutePathname} from "../../../Handler/RouteHandler";
import {hasRight} from "../../../Common/UserCommon";
import {IconButton, Tooltip} from "@mui/material";
import {Edit, Article} from "@mui/icons-material";
import {Link} from "react-router-dom";
import moment from "moment/moment";

function ClosingShopList() {
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const [loading, setLoading] = React.useState(true);

    // List Deposits
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: {filter: true, sort: true}
        },
        {
            name: "shop",
            label: "Boutique",
            options: {filter: true, sort: true}
        },
        {
            name: "closedAt",
            label: "Date fermeture",
            options: {filter: true, sort: true}
        },
        {
            name: "user",
            label: "Utilisateur",
            options: {filter: true, sort: true}
        },
        {
            name: "action",
            label: "Action",
            options: {filter: false, sort: false}
        }
    ];
    
    const getAction = (row) => {
        if ((hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') ||
            hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_CLOSING'))) {
            return (
                <>
                    {
                        <Tooltip title={'Modifier'} placement="left">
                            <Link to={getRoutePathname('shop_management_shop_closing', {id: row.id})}>
                                <IconButton><Edit style={{color: '#17a2b8'}}/></IconButton>
                            </Link>
                        </Tooltip>
                    }
                </>
            );
        }
    };

    React.useEffect(() => {

        setBreadcrumbs({
            title: 'Liste des clotures de caisse',
            context: 'Gestion boutique',
            description: '',
            links: []
        });
        
        setLoading(false);
    }, [])

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'api_shop_management_shop_closing_list'}
                title={'Fermetures de caisses'}
                columns={columns}
                promiseData={(resolve) => {
                    ApiHandler.get({route: 'api_shop_management_closing_list'},
                        (response) => {
                            let data = response.data;
                            for (let index in data) {
                                data[index].action = getAction(data[index]);
                                data[index].id = data[index].id ? data[index].id : '-';
                                data[index].shop = data[index].shop ? data[index].shop : '-';
                                data[index].closedAt = data[index].closedAt;
                                data[index].user = data[index].user ? data[index].user : '-';
                            }
                            resolve(data);
                        });
                }}
            />
            <br/><br/>
        </ContentViewComponent>
    );
}

export default ClosingShopList;
